import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import ConsumptionOrdersDetailSkeleton from "./ConsumptionOrdersDetailSkeleton";
import { ConsumptionOrdersDto } from "../../../../../dtos/documents/ConsumptionOrders/ConsumptionOrdersDto";
import { ConsumptionOrdersModel } from "../../../../../models/Documents/ConsumptionOrders/ConsumptionOrdersModel";
import { NewDocumentModalViewContext } from "../../../../Shared/NewDocumentModalView";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../../helpers/DocumentHelper";
import { AppEntities } from "../../../../../config/entities";
import { importFromExcel, saveObjectToExcel } from "../../../../../helpers/SaveObjectToExcel";
import { NFTabs } from "../../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../../Shared/NewForms/NFTab";
import { DocumentModalViewHeader } from "../../../../Shared/DocumentModalViewHeader";
import { NFTabContainer } from "../../../../Shared/NewForms/NFTabContainer";
import { NFTextInput } from "../../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../../Shared/NewForms/NFDateInput";
import { NFLookupWarehouse } from "../../../../Shared/NewForms/NFLookupWarehouse";
import { NFLookupCompany } from "../../../../Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "../../../../Shared/NewForms/NFLookupDivision";
import { NFormTable } from "../../../../Shared/NewForms/NFormTable";
import { NFIntInput } from "../../../../Shared/NewForms/NFIntInput";
import { NFLookupUnit } from "../../../../Shared/NewForms/NFLookupUnit";
import { NFLookupProduct } from "../../../../Shared/NewForms/NFLookupProduct";
import { NFTextAreaInput } from "../../../../Shared/NewForms/NFTextAreaInput";
import { ConsumptionOrdersDetailFooter } from "./ConsumptionOrdersDetailFooter";
import DocumentDetailViewToolbar from "../../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../../Shared/DetailViews/DetailViewToolbarMoreActions";

interface IProps {
  model: ConsumptionOrdersDto | null;
  modelUpdatedEvent: (newModel: ConsumptionOrdersDto) => void;
}

export const ConsumptionOrdersDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Consumption Order");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ConsumptionOrdersModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;

  const watchProducts = watch("consumptionOrdersGoods");

  useEffect(() => {
    console.log(model);
    register("consumptionOrdersGoods");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("desiredConsumptionDate", model.desiredConsumptionDate);
      setValue("approvedById", model.approvedById);
      setValue("companyId", model.companyId);
      setValue("divisionId", model.divisionId);
      setValue("warehouseId", model.warehouseId);
      setValue("comment", model.comment);
      setValue("createdDate", model.createdDate);
      setValue("consumptionOrdersGoods", model.consumptionOrdersGoods);
    }
  }, [model]);

  useEffect(() => {
    // console.log(watchProducts);
  }, [watchProducts]);

  const documentFileName = "Consumption Orders";

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: ConsumptionOrdersModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <ConsumptionOrdersDetailSkeleton />
      </>
    );
  }

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newQuantity * newProducts[index].price;
    setValue(`consumptionOrdersGoods.${index}.amount`, newAmount);
  };
  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.ConsumptionOrders.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>
      <div className={"modal-container-height"}>
        {/* <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        /> */}
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} fieldName={"documentNumber"} disabled />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFDateInput title={"Desired Consumption Date"} fieldName={"desiredConsumptionDate"} required={true} />
            </Col>
            <Col sm={6}>
              <NFLookupWarehouse fieldName={"warehouseId"} title={"Warehouse"} companyId={watch("companyId")} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupCompany fieldName={"companyId"} title={"Company"} required={true} />
            </Col>
            <Col sm={6}>
              <NFLookupDivision fieldName={"divisionId"} title={"Division"} companyId={watch("companyId")} />
            </Col>
          </Row>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <NFormTable fieldArray={"consumptionOrdersGoods"}>
            <NFIntInput fieldName={"amount"} title={"Amount"} width={100} />
            <NFIntInput fieldName={"price"} title={"Price"} width={100} onValueChanged={handleQuantityChanged} />
            <NFIntInput fieldName={"quantity"} title={"Quantity"} width={100} onValueChanged={handleQuantityChanged} />
            <NFTextInput title="Product Code" fieldName="productCode" />
            <NFTextInput title="Vendor Code" fieldName="vendorCode" />
            <NFLookupUnit title="Unit" fieldName="unitId" width={200} />
            <NFLookupProduct title="Product" fieldName="productId" width={200} />
            <NFLookupProduct fieldName={"productId"} title={"Product"} required={true} width={200} />
            <NFLookupUnit fieldName={"unitId"} title={"unitId"} width={200} />
          </NFormTable>
        </NFTabContainer>
        <NFTabContainer index={2} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <ConsumptionOrdersDetailFooter />
    </FormProvider>
  );
};
